// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dt-page {
  font-family: 'Roboto', Arial, sans-serif;
  color: #000;
  background: #fefefe;
}

/* Sub-navigation */
.dt-nav {
  position: sticky;
  top: 0;
  width: 100%;
  height: 100px;
  background: #fefefe;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-bottom: 1px solid #eee;
}

.dt-nav-logo-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dt-nav-logo-img {
  height: 70px;
  object-fit: contain;
}

.dt-nav-branding {
  margin-left: 10px;
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 12px;
}

.dt-digital-twin {
  color: #57068C;
  letter-spacing: 2px;
  font-weight: bold;
}

.dt-digital-twin-mirror {
  display: inline-block;
  transform: scaleX(-1);
  color: #57068C;
  opacity: 0.5;
  letter-spacing: 2px;
  font-weight: bold;
}

.dt-nav-notes {
  display: flex;
  align-items: center;
  height: 100px;
  white-space: nowrap;
  padding: 0 20px 0 10px;
  font-size: 12px;
  border-right: 1px solid #ccc;
  font-family: 'Montserrat', Arial, sans-serif;
}

.dt-nav-links {
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

.dt-nav-links a {
  color: #333;
  text-decoration: none;
  margin: 0 10px;
  padding: 10px;
  position: relative;
  transition: color 0.3s;
}

.dt-nav-links a::before,
.dt-nav-links a::after {
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background: #57068C;
  content: '';
  opacity: 0;
  transition: all 0.3s;
}

.dt-nav-links a::before {
  top: 0;
  transform: translateY(10px);
}

.dt-nav-links a::after {
  bottom: 0;
  transform: translateY(-10px);
}

.dt-nav-links a:hover::before,
.dt-nav-links a:hover::after {
  opacity: 1;
  transform: translateY(0);
}

/* Banner */
.dt-banner {
  font-family: 'Montserrat', Arial, sans-serif;
  text-align: center;
  height: 125px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.dt-banner-dt1 {
  font-size: 28px;
  color: #57068C;
  letter-spacing: 2px;
  font-weight: bold;
  opacity: 0.75;
}

.dt-banner-sep {
  font-size: 28px;
  color: #999;
  letter-spacing: 2px;
  font-weight: bold;
}

.dt-banner-dt2 {
  display: inline-block;
  font-size: 28px;
  transform: scaleX(-1);
  color: #57068C;
  opacity: 0.25;
  letter-spacing: 2px;
  font-weight: bold;
}

.dt-banner-subtitle {
  font-size: 30px;
  color: #666;
  letter-spacing: 2px;
  font-weight: bold;
}

/* Hero */
.dt-hero {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.dt-hero-message {
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 60px;
  color: #fff;
  text-align: center;
  background: rgba(255, 255, 255, 0.4);
  padding: 10px 0;
  width: 100%;
  z-index: 1;
}

/* Content */
.dt-content {
  padding: 0 0 40px 0;
}

.dt-spacer {
  margin-top: 80px;
}

.dt-band {
  padding: 50px;
  background: #eee;
}

.dt-section-header {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #333;
  font-family: 'Montserrat', Arial, sans-serif;
  margin-bottom: 10px;
}

.dt-section-subheader {
  color: #333;
  font-size: 18px;
  text-align: center;
  margin: 10px 0 20px 0;
  font-family: 'Montserrat', Arial, sans-serif;
}

.dt-section-subtext {
  color: #000;
  font-size: 12px;
  text-align: center;
  margin: 5px 0 20px 0;
  font-family: 'Montserrat', Arial, sans-serif;
}

/* Research Directions */
.dt-research-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  padding: 40px 20px;
}

.dt-research-circle {
  position: relative;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background-position: center;
  background-size: 100% 100%;
  transition: background-size 3s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.dt-research-circle:hover {
  background-size: 150% 150%;
}

.dt-research-title-overlay {
  position: absolute;
  top: 40%;
  width: 100%;
  text-align: center;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: bold;
  font-size: 24px;
  color: #000;
  background: rgba(255, 255, 255, 0.75);
  padding: 10px 0;
  z-index: 1;
}

.dt-research-desc-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.92);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: dtFadeIn 0.4s ease;
  border-radius: 50%;
}

.dt-research-desc-overlay p {
  padding: 40px;
  text-align: center;
  line-height: 1.8;
  font-size: 13px;
  font-family: 'Montserrat', Arial, sans-serif;
}

@keyframes dtFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Events */
.dt-events-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  padding: 40px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.dt-event-card {
  width: 400px;
  min-height: 300px;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s;
}

.dt-event-card:hover {
  transform: translateY(-5px);
}

.dt-spotlight {
  border: 3px solid #e6e635;
}

.dt-spotlight-badge {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(230, 230, 53, 1);
  color: #000;
  padding: 5px 20px;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 2px;
  border-radius: 5px;
  white-space: nowrap;
}

.dt-event-body {
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.dt-event-title {
  font-size: 18px;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #000;
  margin: 0 0 10px 0;
}

.dt-event-date {
  font-size: 13px;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #666;
  border-left: 2px solid #6387ad;
  padding-left: 10px;
  margin-bottom: 10px;
}

.dt-event-desc {
  font-size: 14px;
  font-family: 'Montserrat', Arial, sans-serif;
  line-height: 1.6;
  flex: 1 1;
}

.dt-event-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.dt-event-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.dt-tag {
  background: #eee;
  border-radius: 3px;
  color: #333;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 12px;
  font-family: 'Montserrat', Arial, sans-serif;
  transition: all 0.2s;
}

.dt-tag:hover {
  background: #57068C;
  color: #fff;
}

.dt-event-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  border-radius: 20px;
  background: #16A085;
  color: #fff;
  font-size: 14px;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: bold;
  text-decoration: none;
  border: 2px solid #16A085;
  transition: all 0.15s;
  white-space: nowrap;
}

.dt-event-btn:hover {
  color: #333;
  background: #fff;
}

/* Projects / Flip Cards */
.dt-projects-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  padding: 30px 0;
}

.dt-flip-card {
  position: relative;
  width: 375px;
  min-height: 425px;
  perspective: 1000px;
  cursor: pointer;
}

.dt-flip-card-inner {
  position: relative;
  width: 100%;
  min-height: 425px;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.dt-flipped {
  transform: rotateY(180deg);
}

.dt-flip-card-front,
.dt-flip-card-back {
  position: absolute;
  width: 100%;
  min-height: 425px;
  backface-visibility: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.dt-flip-card-front {
  background: #fff;
}

.dt-flip-card-back {
  background: #fff;
  transform: rotateY(180deg);
  padding: 25px;
  font-size: 14px;
  line-height: 1.7;
  font-family: 'Montserrat', Arial, sans-serif;
  overflow-y: auto;
  max-height: 425px;
}

.dt-status-badge {
  position: absolute;
  right: -10px;
  top: -10px;
  padding: 5px 10px;
  border-radius: 4px;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: bold;
  font-size: 12px;
  z-index: 2;
}

.dt-ongoing {
  background: #f7fa69;
  color: #000;
}

.dt-completed {
  background: #91f2a3;
  color: #000;
}

.dt-project-img {
  width: 100%;
  height: 150px;
  background-position: center;
  background-size: cover;
  transition: background-size 1s;
}

.dt-project-text {
  padding: 15px;
  text-align: center;
}

.dt-project-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: 'Montserrat', Arial, sans-serif;
}

.dt-project-description {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #333;
}

/* People */
.dt-people-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  padding: 40px 20px;
}

.dt-person-card {
  width: 280px;
  background: #f9f9f9;
  border: 1px solid #ccc;
  padding: 0 20px 30px 20px;
  font-family: 'Montserrat', Arial, sans-serif;
  margin-top: 50px;
  transition: transform 0.3s;
}

.dt-person-card:hover {
  cursor: pointer;
}

.dt-person-card:hover .dt-person-circle {
  transform: translateY(-5px) scale(1.02);
}

.dt-person-img-wrap {
  display: flex;
  justify-content: center;
}

.dt-person-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-top: -50px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.3s ease-out;
}

.dt-person-info {
  text-align: center;
  margin-top: 15px;
}

.dt-person-name {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
}

.dt-person-role {
  font-size: 13px;
  color: #555;
}

/* Responsive */
@media (max-width: 1000px) {
  .dt-nav {
    flex-direction: column;
    height: auto;
    padding: 10px 0;
  }

  .dt-nav-notes {
    height: auto;
    padding: 5px 10px;
    border-right: none;
    text-align: center;
  }

  .dt-nav-links a {
    display: inline-block;
    margin: 2px 5px;
    font-size: 14px;
  }

  .dt-hero-message {
    font-size: 32px;
    padding: 10px 20px;
  }

  .dt-banner-dt1,
  .dt-banner-sep,
  .dt-banner-dt2 {
    font-size: 18px;
  }

  .dt-banner-subtitle {
    font-size: 20px;
  }

  .dt-research-circle {
    width: 280px;
    height: 280px;
  }

  .dt-research-title-overlay {
    font-size: 18px;
  }

  .dt-flip-card {
    width: 90%;
    max-width: 375px;
  }

  .dt-event-card {
    width: 90%;
    max-width: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DigitalTwinPage/DigitalTwinPage.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,WAAW;EACX,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,WAAW;EACX,iBAAiB;EACjB,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,4CAA4C;EAC5C,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":[".dt-page {\n  font-family: 'Roboto', Arial, sans-serif;\n  color: #000;\n  background: #fefefe;\n}\n\n/* Sub-navigation */\n.dt-nav {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  height: 100px;\n  background: #fefefe;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-bottom: 1px solid #eee;\n}\n\n.dt-nav-logo-wrap {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dt-nav-logo-img {\n  height: 70px;\n  object-fit: contain;\n}\n\n.dt-nav-branding {\n  margin-left: 10px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 12px;\n}\n\n.dt-digital-twin {\n  color: #57068C;\n  letter-spacing: 2px;\n  font-weight: bold;\n}\n\n.dt-digital-twin-mirror {\n  display: inline-block;\n  transform: scaleX(-1);\n  color: #57068C;\n  opacity: 0.5;\n  letter-spacing: 2px;\n  font-weight: bold;\n}\n\n.dt-nav-notes {\n  display: flex;\n  align-items: center;\n  height: 100px;\n  white-space: nowrap;\n  padding: 0 20px 0 10px;\n  font-size: 12px;\n  border-right: 1px solid #ccc;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.dt-nav-links {\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: bold;\n  margin-left: 15px;\n  font-size: 16px;\n}\n\n.dt-nav-links a {\n  color: #333;\n  text-decoration: none;\n  margin: 0 10px;\n  padding: 10px;\n  position: relative;\n  transition: color 0.3s;\n}\n\n.dt-nav-links a::before,\n.dt-nav-links a::after {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #57068C;\n  content: '';\n  opacity: 0;\n  transition: all 0.3s;\n}\n\n.dt-nav-links a::before {\n  top: 0;\n  transform: translateY(10px);\n}\n\n.dt-nav-links a::after {\n  bottom: 0;\n  transform: translateY(-10px);\n}\n\n.dt-nav-links a:hover::before,\n.dt-nav-links a:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Banner */\n.dt-banner {\n  font-family: 'Montserrat', Arial, sans-serif;\n  text-align: center;\n  height: 125px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #fff;\n  border-bottom: 1px solid #eee;\n}\n\n.dt-banner-dt1 {\n  font-size: 28px;\n  color: #57068C;\n  letter-spacing: 2px;\n  font-weight: bold;\n  opacity: 0.75;\n}\n\n.dt-banner-sep {\n  font-size: 28px;\n  color: #999;\n  letter-spacing: 2px;\n  font-weight: bold;\n}\n\n.dt-banner-dt2 {\n  display: inline-block;\n  font-size: 28px;\n  transform: scaleX(-1);\n  color: #57068C;\n  opacity: 0.25;\n  letter-spacing: 2px;\n  font-weight: bold;\n}\n\n.dt-banner-subtitle {\n  font-size: 30px;\n  color: #666;\n  letter-spacing: 2px;\n  font-weight: bold;\n}\n\n/* Hero */\n.dt-hero {\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.dt-hero-message {\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 60px;\n  color: #fff;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.4);\n  padding: 10px 0;\n  width: 100%;\n  z-index: 1;\n}\n\n/* Content */\n.dt-content {\n  padding: 0 0 40px 0;\n}\n\n.dt-spacer {\n  margin-top: 80px;\n}\n\n.dt-band {\n  padding: 50px;\n  background: #eee;\n}\n\n.dt-section-header {\n  text-align: center;\n  font-size: 36px;\n  font-weight: bold;\n  color: #333;\n  font-family: 'Montserrat', Arial, sans-serif;\n  margin-bottom: 10px;\n}\n\n.dt-section-subheader {\n  color: #333;\n  font-size: 18px;\n  text-align: center;\n  margin: 10px 0 20px 0;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.dt-section-subtext {\n  color: #000;\n  font-size: 12px;\n  text-align: center;\n  margin: 5px 0 20px 0;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n/* Research Directions */\n.dt-research-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 40px;\n  padding: 40px 20px;\n}\n\n.dt-research-circle {\n  position: relative;\n  width: 350px;\n  height: 350px;\n  border-radius: 50%;\n  background-position: center;\n  background-size: 100% 100%;\n  transition: background-size 3s;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.dt-research-circle:hover {\n  background-size: 150% 150%;\n}\n\n.dt-research-title-overlay {\n  position: absolute;\n  top: 40%;\n  width: 100%;\n  text-align: center;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: bold;\n  font-size: 24px;\n  color: #000;\n  background: rgba(255, 255, 255, 0.75);\n  padding: 10px 0;\n  z-index: 1;\n}\n\n.dt-research-desc-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.92);\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: dtFadeIn 0.4s ease;\n  border-radius: 50%;\n}\n\n.dt-research-desc-overlay p {\n  padding: 40px;\n  text-align: center;\n  line-height: 1.8;\n  font-size: 13px;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n@keyframes dtFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Events */\n.dt-events-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 30px;\n  padding: 40px 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.dt-event-card {\n  width: 400px;\n  min-height: 300px;\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s;\n}\n\n.dt-event-card:hover {\n  transform: translateY(-5px);\n}\n\n.dt-spotlight {\n  border: 3px solid #e6e635;\n}\n\n.dt-spotlight-badge {\n  position: absolute;\n  top: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(230, 230, 53, 1);\n  color: #000;\n  padding: 5px 20px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n  letter-spacing: 2px;\n  border-radius: 5px;\n  white-space: nowrap;\n}\n\n.dt-event-body {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.dt-event-title {\n  font-size: 18px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  color: #000;\n  margin: 0 0 10px 0;\n}\n\n.dt-event-date {\n  font-size: 13px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  color: #666;\n  border-left: 2px solid #6387ad;\n  padding-left: 10px;\n  margin-bottom: 10px;\n}\n\n.dt-event-desc {\n  font-size: 14px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  line-height: 1.6;\n  flex: 1;\n}\n\n.dt-event-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 15px;\n}\n\n.dt-event-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.dt-tag {\n  background: #eee;\n  border-radius: 3px;\n  color: #333;\n  font-weight: bold;\n  font-size: 12px;\n  padding: 4px 12px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  transition: all 0.2s;\n}\n\n.dt-tag:hover {\n  background: #57068C;\n  color: #fff;\n}\n\n.dt-event-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 24px;\n  border-radius: 20px;\n  background: #16A085;\n  color: #fff;\n  font-size: 14px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: bold;\n  text-decoration: none;\n  border: 2px solid #16A085;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.dt-event-btn:hover {\n  color: #333;\n  background: #fff;\n}\n\n/* Projects / Flip Cards */\n.dt-projects-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 40px;\n  padding: 30px 0;\n}\n\n.dt-flip-card {\n  position: relative;\n  width: 375px;\n  min-height: 425px;\n  perspective: 1000px;\n  cursor: pointer;\n}\n\n.dt-flip-card-inner {\n  position: relative;\n  width: 100%;\n  min-height: 425px;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n}\n\n.dt-flipped {\n  transform: rotateY(180deg);\n}\n\n.dt-flip-card-front,\n.dt-flip-card-back {\n  position: absolute;\n  width: 100%;\n  min-height: 425px;\n  backface-visibility: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dt-flip-card-front {\n  background: #fff;\n}\n\n.dt-flip-card-back {\n  background: #fff;\n  transform: rotateY(180deg);\n  padding: 25px;\n  font-size: 14px;\n  line-height: 1.7;\n  font-family: 'Montserrat', Arial, sans-serif;\n  overflow-y: auto;\n  max-height: 425px;\n}\n\n.dt-status-badge {\n  position: absolute;\n  right: -10px;\n  top: -10px;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-weight: bold;\n  font-size: 12px;\n  z-index: 2;\n}\n\n.dt-ongoing {\n  background: #f7fa69;\n  color: #000;\n}\n\n.dt-completed {\n  background: #91f2a3;\n  color: #000;\n}\n\n.dt-project-img {\n  width: 100%;\n  height: 150px;\n  background-position: center;\n  background-size: cover;\n  transition: background-size 1s;\n}\n\n.dt-project-text {\n  padding: 15px;\n  text-align: center;\n}\n\n.dt-project-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.dt-project-description {\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  font-family: 'Montserrat', Arial, sans-serif;\n  color: #333;\n}\n\n/* People */\n.dt-people-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 40px;\n  padding: 40px 20px;\n}\n\n.dt-person-card {\n  width: 280px;\n  background: #f9f9f9;\n  border: 1px solid #ccc;\n  padding: 0 20px 30px 20px;\n  font-family: 'Montserrat', Arial, sans-serif;\n  margin-top: 50px;\n  transition: transform 0.3s;\n}\n\n.dt-person-card:hover {\n  cursor: pointer;\n}\n\n.dt-person-card:hover .dt-person-circle {\n  transform: translateY(-5px) scale(1.02);\n}\n\n.dt-person-img-wrap {\n  display: flex;\n  justify-content: center;\n}\n\n.dt-person-circle {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  margin-top: -50px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  transition: all 0.3s ease-out;\n}\n\n.dt-person-info {\n  text-align: center;\n  margin-top: 15px;\n}\n\n.dt-person-name {\n  font-size: 18px;\n  font-weight: bold;\n  padding-bottom: 5px;\n}\n\n.dt-person-role {\n  font-size: 13px;\n  color: #555;\n}\n\n/* Responsive */\n@media (max-width: 1000px) {\n  .dt-nav {\n    flex-direction: column;\n    height: auto;\n    padding: 10px 0;\n  }\n\n  .dt-nav-notes {\n    height: auto;\n    padding: 5px 10px;\n    border-right: none;\n    text-align: center;\n  }\n\n  .dt-nav-links a {\n    display: inline-block;\n    margin: 2px 5px;\n    font-size: 14px;\n  }\n\n  .dt-hero-message {\n    font-size: 32px;\n    padding: 10px 20px;\n  }\n\n  .dt-banner-dt1,\n  .dt-banner-sep,\n  .dt-banner-dt2 {\n    font-size: 18px;\n  }\n\n  .dt-banner-subtitle {\n    font-size: 20px;\n  }\n\n  .dt-research-circle {\n    width: 280px;\n    height: 280px;\n  }\n\n  .dt-research-title-overlay {\n    font-size: 18px;\n  }\n\n  .dt-flip-card {\n    width: 90%;\n    max-width: 375px;\n  }\n\n  .dt-event-card {\n    width: 90%;\n    max-width: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
